export default __webpack_public_path__ + "static/media/IoTPortal-logo.b353750a.svg";